import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "react-phone-input-2/lib/style.css";


// Layout components
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import MobileBookingCTA from "./components/layout/MobileBookingCTA";
import CookieConsent from "./components/layout/CookieConsent";
import AdminLayout from "./components/admin/AdminLayout";

// Pages
import Home from "./pages/Home";
import DisneylandTransfers from "./pages/DisneylandTransfers";
import AirportTransfers from "./pages/AirportTransfers";
import CityTours from "./pages/CityTours";
import Pricing from "./pages/Pricing";
import Booking from "./pages/Booking";
import ThankYou from "./pages/ThankYou";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import About from "./pages/About";
import WhatsApp from "./components/layout/WhatsApp";

// Admin Pages
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminBookings from "./pages/admin/AdminBookings";
import AdminQuotes from "./pages/admin/AdminQuotes";
import AdminRates from "./pages/admin/AdminRates";
import AdminCustomers from "./pages/admin/AdminCustomers";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminSettings from "./pages/admin/AdminSettings";

// Wrapper to conditionally render layout
const AppContent = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  if (isAdminRoute) {
    return (
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="bookings" element={<AdminBookings />} />
          <Route path="quotes" element={<AdminQuotes />} />
          <Route path="rates" element={<AdminRates />} />
          <Route path="customers" element={<AdminCustomers />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="settings" element={<AdminSettings />} />
        </Route>
      </Routes>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-background overflow-x-hidden">
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/disneyland-transfers" element={<DisneylandTransfers />} />
          <Route path="/airport-transfers" element={<AirportTransfers />} />
          <Route path="/city-tours" element={<CityTours />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/about" element={<About />} />
        </Routes>
        <WhatsApp />
      </main>
      
      <Footer />
      <MobileBookingCTA />
      <CookieConsent />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AppContent />
      <Toaster position="top-right" richColors closeButton />
    </BrowserRouter>
  );
}

export default App;
